import { PureComponent } from 'react';
import { connect } from 'unistore/react';

import { monitorActions } from '@utils/store/actions';

class Monitor extends PureComponent {
	componentDidMount() {
		window.addEventListener('unload', this.handleLeavePage);
		this.doMonitorStuffs();
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.monitorEvents.length !== this.props.monitorEvents.length
		) {
			this.doMonitorStuffs();
		}
	}

	componentWillUnmount() {
		window.removeEventListener('unload', this.handleLeavePage);
	}

	handleLeavePage = e => {
		e.preventDefault();
		// e.returnValue = '';
		// const confirmationMessage = '';
		// e.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
		const { monitorTimeout, __sendToMonitor, monitorEvents } = this.props;

		clearTimeout(monitorTimeout);
		if (monitorEvents.length > 0) {
			__sendToMonitor();
		}

		return false;
		// https://stackoverflow.com/questions/39094138/reactjs-event-listener-beforeunload-added-but-not-removed
	};
	// componentWillUnmount() {
	// 	const { monitorTimeout, __sendToMonitor, monitorEvents } = this.props;

	// 	alert(1);
	// 	clearTimeout(monitorTimeout);
	// 	if (monitorEvents.length > 0) {
	// 		__sendToMonitor();
	// 	}
	// }

	doMonitorStuffs = () => {
		const {
			__sendToMonitor,
			__sendingFromMonitor,
			__setMonitorTimeout,
			monitorEvents,
			monitorTimeout,
		} = this.props;

		if (monitorTimeout === null && monitorEvents.length > 0) {
			const newMonitorTimeout = setTimeout(() => {
				__sendToMonitor();
				setTimeout(__sendingFromMonitor, 200);
			}, 5000);

			__setMonitorTimeout(newMonitorTimeout);
		}
	};

	render() {
		return null;
	}
}

export default connect(
	'sendingFromMonitor, monitorEvents, monitorTimeout',
	monitorActions
)(Monitor);
